module.exports = __webpack_public_path__ + "img/sl.ddbd1d9b.svg";